import { Link } from "react-router-dom";
import JsonLd from "@/components/feature/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "";

const privacyPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "개인정보 처리방침 | 실전 일본어 연구소",
  "description": "실전 일본어 연구소의 개인정보 처리방침입니다. 수집 항목, 이용 목적, 보유 기간, 제3자 제공 및 파기 절차를 안내합니다.",
  "url": siteUrl ? `${siteUrl}/privacy` : "",
  "isPartOf": {
    "@type": "WebSite",
    "name": "실전 일본어 연구소",
    "url": siteUrl
  }
};

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={privacyPageSchema} />
      <div className="max-w-4xl mx-auto px-6 md:px-10 py-12">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-600 transition-colors mb-8"
        >
          <i className="ri-arrow-left-line"></i>
          홈으로 돌아가기
        </Link>

        <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
          개인정보 처리방침
        </h1>
        <p className="text-sm text-foreground-600 mb-10">
          시행일: 2026년 7월 31일
        </p>

        <div className="space-y-10 text-foreground-700 leading-relaxed">
          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              1. 개인정보의 수집 항목
            </h2>
            <p className="mb-2">
              연구소는 수강 신청 및 서비스 제공을 위해 다음의 개인정보를 수집할 수 있습니다.
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>이름</li>
              <li>휴대전화 번호</li>
              <li>이메일 주소</li>
              <li>희망 반 및 신청자가 직접 작성한 학습 정보</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              2. 개인정보의 수집 및 이용 목적
            </h2>
            <p className="mb-2">수집한 개인정보는 다음의 목적으로만 이용합니다.</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>수강 신청 접수 및 본인 확인</li>
              <li>수강료 결제 및 수업 안내</li>
              <li>공지사항 및 운영 안내</li>
              <li>문의 응대 및 고객지원</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              3. 개인정보의 보유 및 이용기간
            </h2>
            <p>
              개인정보는 수강 종료 후 1년간 보관한 뒤 지체 없이 파기합니다. 다만 관련 법령에 따라 별도의 보관 의무가 있는 경우에는 해당 기간 동안 보관합니다.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              4. 개인정보의 제3자 제공
            </h2>
            <p>
              연구소는 이용자의 개인정보를 법령에서 정한 경우를 제외하고 제3자에게 제공하지 않습니다.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              5. 개인정보 처리의 위탁
            </h2>
            <p className="mb-2">
              원활한 서비스 제공을 위해 필요한 범위에서 다음 서비스 제공업체를 이용할 수 있습니다.
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Zoom: 온라인 수업 진행</li>
              <li>Google(Gmail): 수강 안내 및 문의 응대</li>
              <li>Supabase: 수강 신청 정보의 안전한 저장 및 관리</li>
              <li>Readdy: 홈페이지 운영, 수강 신청 접수 및 신청 알림 제공</li>
              <li>ClassCard: 온라인 학습 및 단어 학습 서비스 제공</li>
            </ul>
            <p className="mt-2 text-sm text-foreground-600">
              ※ 서비스 변경에 따라 이용 업체는 변경될 수 있습니다.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              6. 개인정보의 파기
            </h2>
            <p>
              보유기간이 종료되거나 처리 목적이 달성된 개인정보는 관련 법령에 따라 안전한 방법으로 지체 없이 파기합니다.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              7. 이용자의 권리
            </h2>
            <p>
              이용자는 언제든지 자신의 개인정보에 대한 열람, 정정, 삭제 및 처리정지를 요청할 수 있으며, 연구소는 관계 법령에 따라 이를 처리합니다.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              8. 문의
            </h2>
            <p>
              개인정보 처리와 관련한 문의는 홈페이지에 기재된 공식 연락처를 통해 접수할 수 있습니다.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}